module.exports = __webpack_public_path__ + "static/media/dark_icn_map_fermata_lex.96af6b11.svg";